import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import AuthenticationNavBar from 'src/pages/login/AuthenticationNavBar';
import './AuthenticationLayout.css';

import image1 from 'src/pages/free-sign-up/resources/images/sign-up-0.png';
import image2 from 'src/pages/free-sign-up/resources/images/sign-up-1.png';
import image3 from 'src/pages/free-sign-up/resources/images/sign-up-2.png';

export const AuthenticationLayout = (): React.ReactElement => {
  const location = useLocation();

  const pagesWithCustomBgrImages: string[] = [
    'account-expired',
    'geo-restricted',
    'notfound',
    'wrong-status',
    'session-expired',
  ];

  const cssClassFromPathname: string = location.pathname.split('/').join('');
  const needsCustomBg: boolean = pagesWithCustomBgrImages.includes(cssClassFromPathname);
  const newLayout = cssClassFromPathname === 'sign-up' || cssClassFromPathname === 'login';

  return (
    <div className="row g-0 light bg-light auth-wrapper-padding">
      <div className="col-lg-6 parts_wrapper">
        <div className="centered_content top_part">{!newLayout && <AuthenticationNavBar />}</div>

        <div className="centered_content center_part">
          <Outlet />
        </div>

        <div className="centered_content bottom_part">
          <div className="powered_by">
            Powered by <span>Smarttech247</span>
          </div>
        </div>
      </div>

      <div
        className={`col-lg-6 d-none d-lg-block ${cssClassFromPathname}-bg authentication-layout-bg${
          needsCustomBg ? '-custom' : ''
        }`}
      >
        {newLayout && (
          <Carousel
            slide
            controls={false}
            indicators
            className="auth-carousel"
          >
            <Carousel.Item className="auth-carousel-item">
              <div className="auth-slide-content">
                <div className="auth-slide-image-wrap">
                  <img
                    className="auth-slide-image"
                    src={image1}
                    alt="Cyber resilience managed for you"
                  />
                </div>

                <div className="auth-carousel-caption">
                  <div className="sign-up-text-overlay">
                    Cyber resilience,
                    <br />
                    <span className="blue-text-gradient">managed for you</span>
                  </div>
                </div>
              </div>
            </Carousel.Item>

            <Carousel.Item className="auth-carousel-item">
              <div className="auth-slide-content">
                <div className="auth-slide-image-wrap">
                  <img
                    className="auth-slide-image"
                    src={image2}
                    alt="Tech agnostic connect all your tools"
                  />
                </div>

                <div className="auth-carousel-caption">
                  <div className="sign-up-text-overlay">
                    Tech Agnostic...
                    <br />
                    <span className="blue-text-gradient">Connect all your tools</span>
                  </div>
                </div>
              </div>
            </Carousel.Item>

            <Carousel.Item className="auth-carousel-item">
              <div className="auth-slide-content">
                <div className="auth-slide-image-wrap">
                  <img
                    className="auth-slide-image"
                    src={image3}
                    alt="View your full risk distribution"
                  />
                </div>

                <div className="auth-carousel-caption">
                  <div className="sign-up-text-overlay">
                    View your full
                    <br />
                    <span className="blue-text-gradient">risk distribution</span>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default AuthenticationLayout;
